import API from '@/services/API'
import { importBatchesByCompany } from '@/graphql/queries'
import { ModelSortDirection } from '@/API'
import { ImportBatch } from '@betterboards/shared/types/API'
import { PlatformImportBatch } from '@betterboards/shared/types/Import'
import { parseImportBatchFailed } from '@/helpers/import/parseImportBatchFailed'

export async function getImportHistory (companyId: string): Promise<PlatformImportBatch[]> {
  const response = await API.graphql({
    query: importBatchesByCompany,
    variables: {
      companyId,
      sortDirection: ModelSortDirection.DESC
    }
  })

  const items = response.data?.importBatchesByCompany?.items ?? []
  return items
    .filter((batch): batch is ImportBatch => batch !== null)
    .map((batch): PlatformImportBatch => ({
      ...batch,
      failed: batch.failed ? parseImportBatchFailed(batch.failed) : null
    }))
}
